import * as React from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import { NavLink } from "react-router-dom";
import { Typography } from "@mui/material";
import LaptopChromebookIcon from '@mui/icons-material/LaptopChromebook';
// import AccountBoxIcon from '@material-ui/icons/AccountBox';
//Icon Imports
import ReportIcon from "@mui/icons-material/Report";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Zoom from "@mui/material/Zoom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SavingsIcon from "@mui/icons-material/Savings";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AssessmentIcon from "@mui/icons-material/Assessment";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { useMediaQuery } from "@mui/material";
import { GrDocumentUpdate } from "react-icons/gr";
//nested icon Imports
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import CategoryIcon from "@mui/icons-material/Category";
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import SellIcon from "@mui/icons-material/Sell";
import Person4Icon from "@mui/icons-material/Person4";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import ScaleIcon from "@mui/icons-material/Scale";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import SiteLogo from "../Assets/images/BHRIGULOGO.gif";
import { useSelector, useDispatch } from "react-redux";
import {
  closeExpand,
  openExpand,
  trigger,
} from "../../redux/reducers/SideExpand";
import MenuListCard from "../MenuListCard/MenuListCard";
import { motion, AnimatePresence } from "framer-motion";
import { Tooltip } from "@mui/material";

import MasterEntryIcon from "../Assets/images/MasterEntryIcon.webp";
import BrandIcon from "../Assets/images/BrandIcon.png";
//import CategoryIcon from '../Assets/images/CategoryIcon.jpg';
import HSNIcon from "../Assets/images/HSNIcon.png";
import ItemIcon from "../Assets/images/ItemIcon.jpeg";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import SuperCategoryIcon from "../Assets/images/SuperCategoryIcon.jpg";
import AccessMasterIcon from "../Assets/images/AccessMasterIcon.png";
import AccountMasterIcon from "../Assets/images/AccountMasterIcon.png";
import InvoiceIcon from "../Assets/images/InvoiceIcon.png";
import SupplierIcon from "../Assets/images/SupplierIcon.webp";
import CatalogIcon from "../Assets/images/CatalogIcon.jpg";
import SaleOrderIcon from "../Assets/images/SaleOrderIcon.png";
import ShoppingIcon from "../Assets/images/shopping_1964545.png";
import GastroIcon from "../Assets/images/rating_4964421.png";

import SalesReport from "../Assets/images/SalesReport.png";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountMasterIcon2 from "../Assets/images/accountMasterEntry.png";

import stockUpdate from "../Assets/images/stockUpdate.png";
import {
  ArtTrack,
  AspectRatioOutlined,
  BluetoothSearchingOutlined,
  Bolt,
  HistoryEduOutlined,
  LoginTwoTone,
  Newspaper,
  PagesTwoTone,
  Photo,
  Podcasts,
  TempleBuddhist,
  TempleHinduOutlined,
  TripOriginRounded,
  UTurnLeft,
  VerticalAlignTopOutlined,
} from "@mui/icons-material";
import { Book, BookFill } from "react-bootstrap-icons";

const drawerWidth = 270;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const NavToolTip = ({ text, children }) => {
  return (
    <Tooltip
      TransitionComponent={Zoom}
      leaveDelay={200}
      title={text}
      placement="right"
      arrow
      sx={{ fontSize: "16px" }}
    >
      {children}
    </Tooltip>
  );
};

export default function Sidebar() {
  //#region code
  const dispatch = useDispatch();
  const open = useSelector((state) => state.sideExpand.open);
  const isMobile = useMediaQuery("(max-width:600px)");

  const { is_super, is_admin } = useSelector((state) => state.GlobalVariables);
  const { company_type } = useSelector((state) => state.admin);

  const [isMenuExpanded, setIsMenuExpanded] = React.useState(false);
  const [selectedMenu, setSelectedMenu] = React.useState(0);

  React.useEffect(() => {
    if (isMobile) {
      dispatch(closeExpand());
    } else {
      dispatch(openExpand());
    }
  }, [isMobile]);

  const handleDrawerOpen = () => {
    dispatch(trigger());
  };

  const handleDrawerClose = () => {
    // setOpen(false);
    dispatch(trigger());
  };

  const handleExpand = (number) => {
    setSelectedMenu(number);
    setIsMenuExpanded(!isMenuExpanded);
  };
  //#endregion

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: "#000000",
          },
        }}
      >
        <DrawerHeader>
          <img
            src={SiteLogo}
            alt="logo"
            width="90%"
            height="60%"
            hidden={open ? false : true}
            style={{ marginTop: "-20px" }}
          />

          <IconButton onClick={handleDrawerClose}>
            {!open ? (
              <ArrowForwardIosIcon sx={{ color: "white" }} />
            ) : (
              <ArrowBackIosNewIcon sx={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />

        <NavLink
          to="/dashboard"
          style={{ textDecoration: "none", color: "#FFF4F4" }}
        >
          <ListItem disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                }}
              >
                <NavToolTip text="Dashboard">
                  <DashboardIcon sx={{ color: "white" }} />
                </NavToolTip>
              </ListItemIcon>
              <ListItemText
                primary={"Dashboard"}
                sx={{ opacity: open ? 1 : 0 }}
              />
            </ListItemButton>
          </ListItem>
        </NavLink>

        <Divider
          variant="middle"
          sx={{
            backgroundColor: "#6270e488",
            marginBottom: 2,
          }}
        />

        <MenuListCard
          number={0}
          text={"Configuration Master"}
          icon={
            <NavToolTip text="Configuration Master">
              <img
                src={MasterEntryIcon}
                style={{
                  width: "25px",
                  filter: "invert(100%)",
                }}
                alt="Configuration Master"
              />
            </NavToolTip>
          }
          secondaryIcon={
            isMenuExpanded && selectedMenu === 0 ? (
              <ArrowDropUpIcon sx={{ color: "white" }} />
            ) : (
              <ArrowDropDownIcon sx={{ color: "white" }} />
            )
          }
          isExpandable={true}
          handleExpand={handleExpand}
        />
        <AnimatePresence>
          {isMenuExpanded && selectedMenu === 0 && (
            <Box
              component={motion.div}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              transition={{ duration: 0.5 }}
              exit={{ height: 0, opacity: 0, transition: { duration: 0.3 } }}
            >
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />

              {/* <MenuListCard
                url="/master-entry/brand"
                nested={true}
                fSize="0.9rem"
                text={"Speciality"}
                icon={
                  <NavToolTip text="Speciality">
                    <img
                      src={BrandIcon}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="Speciality"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* <MenuListCard url='/master-entry/batch' nested={true} fSize='0.9rem' text={'Batch'} icon={<NavToolTip text='Batch'><BatchPredictionIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} /> */}

              <MenuListCard
                url="/master-entry/category"
                nested={true}
                fSize="0.9rem"
                text={"Category"}
                icon={
                  <NavToolTip text="Category">
                    <CategoryIcon sx={{ color: "white" }} />
                    {/* <img
                                src={CategoryIcon}
                                style={{
                                    width: '25px',
                                    filter: 'invert(100%)', // Apply the invert filter
                                }}
                                alt="Category"
                            /> */}
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />

              <MenuListCard
                url="/master-entry/group"
                nested={true}
                fSize="0.9rem"
                text={"Sub-Category"}
                icon={
                  <NavToolTip text="Sub-Category">
                    <SellIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />

              <MenuListCard
                url="/master-entry/podcaster"
                nested={true}
                fSize="0.9rem"
                text={"Podcaster"}
                icon={
                  <NavToolTip text="Podcaster">
                    <AccountBoxIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />

              <MenuListCard
                url="/transaction-entry/resource-master"
                nested={true}
                fSize="0.9rem"
                text={"Resource Master"}
                icon={
                  <NavToolTip text="Resource Master">
                    <img
                      src={InvoiceIcon}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="Resource Master"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />

              {/* <MenuListCard
                url="/master-entry/podcast"
                nested={true}
                fSize="0.9rem"
                text={"Podcast"}
                icon={
                  <NavToolTip text="Podcast">
                    <Podcasts sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}
              <MenuListCard
                url="/master-entry/gotra"
                nested={true}
                fSize="0.9rem"
                text={"Gotra"}
                icon={
                  <NavToolTip text="Gotra">
                    <TempleHinduOutlined sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/master-entry/kuldevi"
                nested={true}
                fSize="0.9rem"
                text={"Kuldevi"}
                icon={
                  <NavToolTip text="Kuldevi">
                    <TempleBuddhist sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />

              {/* <MenuListCard
                url="/master-entry/units"
                nested={true}
                fSize="0.9rem"
                text={"Duration"}
                icon={
                  <NavToolTip text="Duration">
                    <ScaleIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* <MenuListCard
                url="/master-entry/item"
                nested={true}
                fSize="0.9rem"
                text={"Pain Areas"}
                icon={
                  <NavToolTip text="Pain Areas">
                    <ViewInArIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* <MenuListCard
                url="/master-entry/questionnaires"
                nested={true}
                fSize="0.9rem"
                text={"Questionnaire"}
                icon={
                  <NavToolTip text="Questionnaire">
                    <ViewInArIcon sx={{ color: "white" }} />
                   
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* <MenuListCard
                url="/master-entry/solution"
                nested={true}
                fSize="0.9rem"
                text={"Solutions"}
                icon={
                  <NavToolTip text="Solutions">
                    <ViewInArIcon sx={{ color: "white" }} />
                    
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* <MenuListCard
                url="/master-entry/questions"
                nested={true}
                fSize="0.9rem"
                text={"Questions"}
                icon={
                  <NavToolTip text="Questions">
                    <QuestionMarkIcon sx={{ filter: 'invert(100%)' }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* <MenuListCard
                url="/master-entry/hsn"
                nested={true}
                fSize="0.9rem"
                text={"HSN"}
                icon={
                  <NavToolTip text="HSN">
                    <img
                      src={HSNIcon}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="HSN"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* <MenuListCard url='/updateProduct' nested={true} fSize='0.9rem' number={2} text={'Update Product'} icon={<NavToolTip text='UpdateProduct'><Inventory2Icon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} isExpandable={false} /> */}

              {/* <MenuListCard
                url="/master-entry/super-category"
                nested={true}
                fSize="0.9rem"
                number={2}
                text={"Super Category"}
                icon={
                  <NavToolTip text="Super Category">
                    <img
                      src={SuperCategoryIcon}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="Super Category"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
                isExpandable={false}
              /> */}

              {/* <MenuListCard
                url="/master-entry/location"
                nested={true}
                fSize="0.9rem"
                number={14}
                text={"Location"}
                icon={
                  <NavToolTip text="Location">
                    <LocationOnIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
                isExpandable={false}
              /> */}

              {/* <MenuListCard
                url="/master-entry/catalog"
                nested={true}
                fSize="0.9rem"
                number={14}
                text={"Catalog"}
                icon={
                  <NavToolTip text="Catalog">
                    <img
                      src={CatalogIcon}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="Catalog"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
                isExpandable={false}
              /> */}

              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
            </Box>
          )}
        </AnimatePresence>

        {/* transaction  */}
        <MenuListCard
          number={1}
          text={"Transaction"}
          icon={
            <NavToolTip text="Transaction">
              <img
                src={MasterEntryIcon}
                style={{
                  width: "25px",
                  filter: "invert(100%)",
                }}
                alt="Transaction"
              />
            </NavToolTip>
          }
          secondaryIcon={
            isMenuExpanded && selectedMenu === 1 ? (
              <ArrowDropUpIcon sx={{ color: "white" }} />
            ) : (
              <ArrowDropDownIcon sx={{ color: "white" }} />
            )
          }
          isExpandable={true}
          handleExpand={handleExpand}
        />
        <AnimatePresence>
          {isMenuExpanded && selectedMenu === 1 && (
            <Box
              component={motion.div}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              transition={{ duration: 0.5 }}
              exit={{ height: 0, opacity: 0, transition: { duration: 0.3 } }}
            >
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/numerology"
                  nested={true}
                  fSize="0.9rem"
                  text={"Numerology"}
                  icon={
                    <NavToolTip text="Numerology">
                      <img
                        src={BrandIcon}
                        style={{
                          width: "25px",
                          filter: "invert(100%)",
                        }}
                        alt="Numerology"
                      />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

              {/* astrology */}
              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/astrology"
                  nested={true}
                  fSize="0.9rem"
                  text="Astrology"
                  icon={
                    <NavToolTip text="Astrology">
                      <img
                        src={SaleOrderIcon}
                        style={{ width: "25px", filter: "invert(100%)" }}
                        alt="astrology"
                      />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

               {/* Shopping */}
              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/shopping"
                  nested={true}
                  fSize="0.9rem"
                  text="Shopping"
                  icon={
                    <NavToolTip text="Shopping">
                      <img
                        src={ShoppingIcon}
                        style={{ width: "25px", filter: "invert(100%)" }}
                        alt="Shopping"
                      />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

               {/* gastronomy */}
              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/gastronomy"
                  nested={true}
                  fSize="0.9rem"
                  text="Gastronomy"
                  icon={
                    <NavToolTip text="Gastronomy">
                      <img
                        src={GastroIcon}
                        style={{ width: "25px", filter: "invert(100%)" }}
                        alt="Gastronomy"
                      />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/blog"
                  nested={true}
                  fSize="0.9rem"
                  text={"Blog"}
                  icon={
                    <NavToolTip text="Blog">
                      <BluetoothSearchingOutlined sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

              {/* {is_super === 1 && (
                <MenuListCard
                  url="/transaction-entry/vlog"
                  nested={true}
                  fSize="0.9rem"
                  text={"Vlog"}
                  icon={
                    <NavToolTip text="Vlog">
                      <VerticalAlignTopOutlined sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/vastu"
                  nested={true}
                  fSize="0.9rem"
                  text={"Vastu"}
                  icon={
                    <NavToolTip text="Vastu">
                      <AcUnitIcon sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}


               {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/book-entry"
                  nested={true}
                  fSize="0.9rem"
                  text={"Dharohar"}
                  icon={
                    <NavToolTip text="Dharohar">
                      <LaptopChromebookIcon sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}


              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/photography"
                  nested={true}
                  fSize="0.9rem"
                  text={"Photography"}
                  icon={
                    <NavToolTip text="Photography">
                      <Photo sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}
{/* 
               {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/art"
                  nested={true}
                  fSize="0.9rem"
                  text={"Art"}
                  icon={
                    <NavToolTip text="Art">
                      <ArtTrack sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

              <MenuListCard
                url="/transaction-entry/inerve"
                nested={true}
                fSize="0.9rem"
                text={"Inerve"}
                icon={
                  <NavToolTip text="Inerve">
                    <Newspaper sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/transaction-entry/ad"
                nested={true}
                fSize="0.9rem"
                text={"Ad"}
                icon={
                  <NavToolTip text="Ad">
                    <Podcasts sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              {/* <MenuListCard
                url="/transaction-entry/podcast"
                nested={true}
                fSize="0.9rem"
                text={"Podcast"}
                icon={
                  <NavToolTip text="Podcast">
                    <Podcasts sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

               {/* <MenuListCard
                url="/transaction-entry/career"
                nested={true}
                fSize="0.9rem"
                text={"Career"}
                icon={
                  <NavToolTip text="Career">
                    <LocalLibraryIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              /> */}

              {/* {(is_admin === true || is_super === 1) && (
                <MenuListCard
                  url="/transaction-entry/kuldevi-addition"
                  nested={true}
                  fSize="0.9rem"
                  text={"Cat kuldevi/gotra"}
                  icon={
                    <NavToolTip text="Cat kuldevi/gotra">
                      <CategoryIcon sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

                {/* {is_super === 1 && (
                <MenuListCard
                  url="/transaction-entry/daily-page-url"
                  nested={true}
                  fSize="0.9rem"
                  text={"Daily update"}
                  icon={
                    <NavToolTip text="Daily update">
                      <UTurnLeft sx={{ color: "white" }} />
                    </NavToolTip>
                  }
                  secondaryIcon={<ArrowDropDownIcon />}
                />
              )} */}

              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
            </Box>
          )}
        </AnimatePresence>

        {/* <MenuListCard
          url="/enquiry"
          number={3}
          text={"Member Enquiries"}
          icon={
            <NavToolTip text="Member Enquiries">
              <PagesTwoTone sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}

        {/* {is_super === 1 && (
          <MenuListCard
            url="/logs"
            number={3}
            text={"Aadhar logs"}
            icon={
              <NavToolTip text="Logs">
                <HistoryEduOutlined sx={{ color: "white" }} />
              </NavToolTip>
            }
            secondaryIcon={<ArrowDropDownIcon />}
            isExpandable={false}
          />
        )} */}

         {/* {is_super === 1 && (
          <MenuListCard
            url="/user-logs"
            number={3}
            text={"User logs"}
            icon={
              <NavToolTip text="User Logs">
                <LoginTwoTone sx={{ color: "white" }} />
              </NavToolTip>
            }
            secondaryIcon={<ArrowDropDownIcon />}
            isExpandable={false}
          />
        )} */}

        {/* <MenuListCard
          url="/prescriptions"
          number={3}
          text={"Prescriptions"}
          icon={
            <NavToolTip text="Prescriptions">
              <img
                src={InvoiceIcon}
                style={{
                  width: "25px",
                  filter: "invert(100%)",
                }}
                alt="Prescriptions"
              />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}
        {/* <MenuListCard
          url="/social-media-configuration"
          number={3}
          text={"Media Settings"}
          icon={
            <NavToolTip text="Socail settings">
              <ConnectWithoutContactIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}
        {/* <MenuListCard
          url="/invoice"
          number={12}
          text={"Invoice"}
          icon={
            <NavToolTip text="Invoice">
              <img
                src={InvoiceIcon}
                style={{
                  width: "25px",
                  filter: "invert(100%)",
                }}
                alt="Invoice"
              />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}

        {/* <MenuListCard
          url="/subscriptions"
          number={13}
          // fSize="0.9rem"
          text={"Subscriptions"}
          icon={
            <NavToolTip text="Subscriptions">
              <AssessmentIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}

        {/* <MenuListCard
          url="/subscriptions-order"
          number={13}
          // fSize="0.9rem"
          text={"Subscriptions Order"}
          icon={
            <NavToolTip text="Subscriptions Order">
              <SubscriptionsIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        />
        <MenuListCard
          url="/subscriptions-dispatch"
          number={13}
          // fSize="0.9rem"
          text={"Subscriptions Dispatch"}
          icon={
            <NavToolTip text="Subscriptions Dispatch">
              <LoyaltyIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}

        {/* <MenuListCard
          url="/sales-order"
          number={14}
          // fSize="0.9rem"
          text={"Sales Order"}
          icon={
            <NavToolTip text="Sales Order">
              <img
                src={SaleOrderIcon}
                style={{
                  width: "25px",
                  filter: "invert(100%)",
                }}
                alt="Sales Order"
              />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}

        {/* Account Master stated */}

        {/* <MenuListCard
          number={10}
          text={
            <Typography sx={{ fontSize: "14px" }}> Account Master</Typography>
          }
          icon={
            <NavToolTip text="Account Master">
              <img
                src={AccountMasterIcon2}
                style={{
                  width: "25px",
                  filter: "invert(100%)",
                }}
                alt="Account Master"
              />
            </NavToolTip>
          }
          secondaryIcon={
            isMenuExpanded && selectedMenu === 10 ? (
              <ArrowDropUpIcon sx={{ color: "white" }} />
            ) : (
              <ArrowDropDownIcon sx={{ color: "white" }} />
            )
          }
          isExpandable={true}
          handleExpand={handleExpand}
        /> */}
        {/* <AnimatePresence>
          {isMenuExpanded && selectedMenu === 10 && (
            <Box
              component={motion.div}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              transition={{ duration: 0.5 }}
              exit={{ height: 0, opacity: 0, transition: { duration: 0.3 } }}
            >
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
              <MenuListCard
                url="/account-master-entry/customers"
                nested={true}
                fSize="0.9rem"
                text={"Members"}
                icon={
                  <NavToolTip text="Customers">
                    <PeopleAltIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/account-master-entry/account-master"
                nested={true}
                fSize="0.9rem"
                text={"Account Master"}
                icon={
                  <NavToolTip text="Account Master">
                    <img
                      src={AccountMasterIcon}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="Account Master"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
                isExpandable={false}
              />
            </Box>
          )}
        </AnimatePresence> */}

        {/* account master entery end */}

        {/* <MenuListCard url='/customers' number={1} text={'Customers'} icon={<NavToolTip text='Customers'>
                    <PeopleAltIcon sx={{ color: 'white' }} />
                </NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} isExpandable={false} /> */}

        {/* <MenuListCard url='/accessMaster' number={1} text={'Access Master'} icon={<NavToolTip text='Access Master'>
                    <img
                        src={AccessMasterIcon}
                        style={{
                            width: '25px',
                            filter: 'invert(100%)',
                        }}
                        alt="Access Master"
                    />
                </NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} isExpandable={false} /> */}

        {/* <MenuListCard url='/invoice' number={3} text={'Invoice'} icon={<NavToolTip text='Invoice'>
                    <img
                        src={InvoiceIcon}
                        style={{
                            width: '25px',
                            filter: 'invert(100%)',
                        }}
                        alt="Invoice"
                    />
                </NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} isExpandable={false} /> */}

        {/* <MenuListCard
          url="/supplier"
          number={2}
          text={"Suppliers"}
          icon={
            <NavToolTip text="Suppliers">
              <img
                src={SupplierIcon}
                style={{
                  width: "25px",
                  filter: "invert(100%)",
                }}
                alt="Supplier"
              />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}

        {/* <MenuListCard
          number={5}
          text={"Transaction"}
          icon={
            <NavToolTip text="Transaction">
              <AccountBalanceIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={
            isMenuExpanded && selectedMenu === 5 ? (
              <ArrowDropUpIcon sx={{ color: "white" }} />
            ) : (
              <ArrowDropDownIcon sx={{ color: "white" }} />
            )
          }
          isExpandable={true}
          handleExpand={handleExpand}
        />

        <AnimatePresence>
          {isMenuExpanded && selectedMenu === 5 && (
            <Box
              component={motion.div}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "100%", opacity: 1 }}
              transition={{ duration: 0.5 }}
              exit={{ height: 0, opacity: 0, transition: { duration: 0.3 } }}
            >
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
              <MenuListCard
                url="/transaction/create-vouchers"
                nested={true}
                fSize="0.9rem"
                text={"Cash Voucher"}
                icon={
                  <NavToolTip text="Cash Voucher">
                    <MonetizationOnIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/transaction/journal-entry"
                nested={true}
                fSize="0.9rem"
                text={"Journal Voucher"}
                icon={
                  <NavToolTip text="Journal Voucher">
                    <PriceChangeIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/transaction/Gst-transaction-report"
                nested={true}
                fSize="0.9rem"
                text={"Gst Transaction"}
                icon={
                  <NavToolTip text="Gst Transaction">
                    <ReceiptLongIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/transaction/stockUpdate"
                nested={true}
                fSize="0.9rem"
                text={"Stock Update"}
                icon={
                  <NavToolTip text="Stock Update">
                    <img
                      src={stockUpdate}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="Super Category"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />

              <MenuListCard
                url="/transaction/purchase-order"
                nested={true}
                fSize="0.9rem"
                text={"Purchase Order"}
                icon={
                  <NavToolTip text="Purchase Order">
                    <Person4Icon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/transaction/purchase-bill"
                nested={true}
                fSize="0.9rem"
                text={"Purchase Bill"}
                icon={
                  <NavToolTip text="Purchase Bill">
                    <ViewInArIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />

              <MenuListCard
                url="/transaction/dispatch"
                nested={true}
                fSize="0.9rem"
                text={"Dispatch"}
                icon={
                  <NavToolTip text="Dispatch">
                    <LocalShippingIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
                isExpandable={false}
              />
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
            </Box>
          )}
        </AnimatePresence> */}

        {/* <MenuListCard
          number={6}
          text={"Reports"}
          icon={
            <NavToolTip text="Reports">
              <ReportIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={
            isMenuExpanded && selectedMenu === 6 ? (
              <ArrowDropUpIcon sx={{ color: "white" }} />
            ) : (
              <ArrowDropDownIcon sx={{ color: "white" }} />
            )
          }
          isExpandable={true}
          handleExpand={handleExpand}
        />

        <AnimatePresence>
          {isMenuExpanded && selectedMenu === 6 && (
            <Box
              component={motion.div}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "100%", opacity: 1 }}
              transition={{ duration: 0.5 }}
              exit={{ height: 0, opacity: 0, transition: { duration: 0.3 } }}
            >
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
              <MenuListCard
                url="/report/outstanding-report"
                nested={true}
                fSize="0.9rem"
                text={"Outstanding Report"}
                icon={
                  <NavToolTip text="Outstanding Report">
                    <SellIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <MenuListCard
                url="/report/gst-invoice-report"
                nested={true}
                fSize="0.9rem"
                text={"Gst Invoice Report"}
                icon={
                  <NavToolTip text="Gst Invoice Report">
                    <PriceChangeIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
              <MenuListCard
                url="/report/sales-report"
                nested={true}
                fSize="0.9rem"
                text={"Sales Order Report"}
                icon={
                  <NavToolTip text="Sales Order Report">
                    <img
                      src={SalesReport}
                      style={{
                        width: "25px",
                        filter: "invert(100%)",
                      }}
                      alt="Supplier"
                    />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
              <MenuListCard
                url="/report/sales-summary-report"
                nested={true}
                fSize="0.9rem"
                text={"Sales Order Summary"}
                icon={
                  <NavToolTip text="Sales Order Summary">
                    <SummarizeIcon sx={{ color: "white" }} />
                  </NavToolTip>
                }
                secondaryIcon={<ArrowDropDownIcon />}
              />
              <Divider sx={{ backgroundColor: "black", marginLeft: 5 }} />
            </Box>
          )}
        </AnimatePresence> */}

        {/* <MenuListCard url='/report/outstanding-report' number={7} text={'Outstanding Report'} icon={<NavToolTip text='Outstanding Report'><SellIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} /> */}
        {/* <MenuListCard
          url="/unregister-payment"
          number={7}
          text={"Unregister Payments"}
          icon={
            <NavToolTip text="Unregister Payments">
              <SavingsIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        /> */}

        {/* <MenuListCard url='/dispatch-details' number={6} text={'Dispatch Details'} icon={<NavToolTip text='Dispatch Details'><LocalShippingIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} isExpandable={false} /> */}
        {/* <MenuListCard number={9} text={'Reports'} icon={<NavToolTip text='Reports'><SummarizeIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon sx={{ color: 'white' }} />} isExpandable={true} handleExpand={handleExpand} />
                <AnimatePresence>
                    {(isMenuExpanded && selectedMenu === 9) && (<Box
                        component={motion.div}
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: '100%', opacity: 1 }}
                        transition={{ duration: 0.5 }}
                        exit={{ height: 0, opacity: 0, transition: { duration: 0.3 } }}
                    >
                        <Divider sx={{ backgroundColor: 'black', marginLeft: 5 }} />
                        <MenuListCard url='/report/srs' nested={true} fSize='0.9rem' text={'Sales Register Summary'} icon={<NavToolTip text='Sales Register Summary'><CategoryIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} />
                        <MenuListCard url='/report/sri' nested={true} fSize='0.9rem' text={'Sales Register Itemwise'} icon={<NavToolTip text='Sales Register Itemwise'><SellIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} />
                        <MenuListCard url='/report/order-report' nested={true} fSize='0.9rem' text={'Order Report Itemwise'} icon={<NavToolTip text='Order Report Itemwise'><Person4Icon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} />
                        <MenuListCard url='/report/customer-report' nested={true} fSize='0.9rem' text={'Customer Report'} icon={<NavToolTip text='Customer Report'><ViewInArIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} />
                        <MenuListCard url='/report/purchase-report' nested={true} fSize='0.9rem' text={'Purchase Report'} icon={<NavToolTip text='Purchase Report'><ScaleIcon sx={{ color: 'white' }} /></NavToolTip>} secondaryIcon={<ArrowDropDownIcon />} />
                        <Divider sx={{ backgroundColor: 'black', marginLeft: 5 }} />
                    </Box>)}
                </AnimatePresence> */}

        {Boolean(is_admin) === true && (
          <MenuListCard
            url="/register-company"
            number={10}
            text={"Company"}
            icon={
              <NavToolTip text="Company">
                <AppRegistrationIcon sx={{ color: "white" }} />
              </NavToolTip>
            }
            secondaryIcon={<ArrowDropDownIcon />}
            isExpandable={false}
          />
        )}
        {/* {
          is_admin &&
          <MenuListCard
            url="/configuration"
            number={11}
            text={"Configuration"}
            icon={
              <NavToolTip text="Configuration">
                <SettingsIcon sx={{ color: "white" }} />
              </NavToolTip>
            }
            secondaryIcon={<ArrowDropDownIcon />}
            isExpandable={false}
          />
        } */}
        <MenuListCard
          number={12}
          url="/profile"
          text={"Profile"}
          icon={
            <NavToolTip text="Profile">
              <AccountBoxIcon sx={{ color: "white" }} />
            </NavToolTip>
          }
          secondaryIcon={<ArrowDropDownIcon />}
          isExpandable={false}
        />

        {/* {
          is_admin &&
          <MenuListCard
            number={12}
            url="/access-master"
            text={"Access Master"}
            icon={
              <NavToolTip text="Access Master">
                <AccountBoxIcon sx={{ color: "white" }} />
              </NavToolTip>
            }
            secondaryIcon={<ArrowDropDownIcon />}
            isExpandable={false}
          />
        }  */}

        <Divider />
      </Drawer>
    </Box>
  );
}
